// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"78148d44","258":"7fdd076b"}[chunkId] + ".chunk.css";
};